import {useState, useEffect} from 'react';
import {useDropzone} from 'react-dropzone'
import './FileUploadBox.scss'
import {i18n} from "../../../Utils/i18n/i18n";
import {onProgress} from "./FileUploadBoxLib";

export const FileUploadBox = ({

                                  className,
                                  children,
                                  style,
                                  accept,
                                  maxFiles = 1,
                                  onFileUploaded,
                                  uploadFiles,
                                  maxSize= 50000000, // 50MB in bytes
                                  minSize= 0,
                                  supportedFileTypesForNotifications,
                                  resetUploadState = false
                              }) => {
    const [progress, setProgress] = useState(0)
    const [dragOver, setDragOver] = useState(false)
    const [fileAccepted, setFileAccepted] = useState(false)

    // Reset upload state when resetUploadState prop changes
    useEffect(() => {
        if (resetUploadState) {
            setProgress(0);
            setFileAccepted(false);
            setDragOver(false);
        }
    }, [resetUploadState]);

    const localOnProgress = (event) => {
        const {progress} = onProgress(event)
        setProgress(progress)
        if (progress === 100 && onFileUploaded) {
            onFileUploaded()
        }
    }

    const onDrop = (acceptedFiles) => {
        if (acceptedFiles.length) {
            setFileAccepted(true)
            return uploadFiles({
                files: acceptedFiles,
                onProgress: localOnProgress,

            })
        } else return null
    }

    const getInnerComponent = () => {
        if (progress && progress !== 100) {
            return <div>{String(i18n.translate('uploadBox.uploading')) + progress + '%'}</div>
        } else if (progress && progress === 100) {
            return <div>{i18n.translate('uploadBox.uploaded')}</div>
        } else {
            return children
        }
    }
    const onDragOverChange = (dragOver) => () => {
        setDragOver(dragOver)
    }
    const {
        getRootProps,
        getInputProps,
    } = useDropzone({
        onDrop,
        accept,
        onDragEnter: onDragOverChange(true),
        onDragLeave: onDragOverChange(false),
        maxFiles,
        maxSize,
        minSize,
        onDropRejected: (fileRejections, event) => {
            alert(i18n.translate('uploadBox.uploadFailed'))
        }
    });
    // Convert bytes to MB using binary (1024*1024) and round to nearest integer
    const maxSizeMB = Math.round(maxSize / (1024 * 1024));
    // For sizes >= 1024MB, display as GB
    const displaySize = maxSizeMB >= 1024
        ? `${Math.round(maxSizeMB / 1024)}GB`
        : `${maxSizeMB}MB`;
    return <div
        {...getRootProps()}
        style={{...style, position: 'relative'}}
        className={`dropzone file-upload ${className} ${dragOver ? 'dragOver' : ''} ${fileAccepted ? 'accepted' : ''}`}>
        <div className="progressOrChild">
            {getInnerComponent()}
            <div className="file-upload-messages">
                {maxSize && <div
                    className="file-upload-description">{i18n.translate('uploadBox.maxFileSize', {context: {maxFileSize: displaySize}})}</div>}
                { accept &&
                    <div className="file-upload-description">{i18n.translate('uploadBox.onlyFileTypes', {context: {fileTypes: supportedFileTypesForNotifications}})}</div>}

            </div>

        </div>
        <input
            {...getInputProps()}
            style={{
                opacity: '0',
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%'
            }}
        />

    </div>

};